import * as SearchActions from './actions';

const initialState = { fethced: null, searchPageHeight: null }

const reserveReducer = (state = initialState, action) => {
  switch (action.type) {
    case SearchActions.FETCHED_JABRATOKENS: {
      return {
        ...state,
        fetched: true,
        searchPageHeight: action.searchPageHeight
      }
    }
    case SearchActions.SEARCHPAGE_HEIGHT_DETERMINDED: {
      return {
        ...state,
        fetched: false,
        searchPageHeight: action.searchPageHeight
      }
    }
    default: {
      return state;
    }
  }
}

export default reserveReducer;
